// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"b2a205d9","727":"0346acbd"}[chunkId] + ".chunk.js";
};